import { render, staticRenderFns } from "./ObservationLis.vue?vue&type=template&id=1a44ce84&scoped=true&"
import script from "./ObservationLis.vue?vue&type=script&lang=js&"
export * from "./ObservationLis.vue?vue&type=script&lang=js&"
import style0 from "./ObservationLis.vue?vue&type=style&index=0&id=1a44ce84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a44ce84",
  null
  
)

export default component.exports